<template>
    <div class="modal modal-open" id="modal-sale-service">
        <div class="modal-overflow">
            <div class="modal-window">
                <button
                    type="button"
                    class="btn btn-modal-close"
                    @click="handleClose"
                >
                    <i class="icon icon-cancel"></i>
                </button>
                <div class="modal-body">
                    <div class="row">
                        <div class="col-xl-12 col-lg-12 group-row">
                            <div class="group-row__label">Deal</div>
                            <div class="row">
                                <div class="col-xl-8 col-lg-8 col-md-8">
                                    <div
                                        class="form-field form-field--tree"
                                        style="padding-right: 12px"
                                    >
                                        <label for="service_id">Service</label>
                                        <treeselect
                                            v-model="service.services[0].id"
                                            id="service_id"
                                            name="service_id"
                                            :multiple="false"
                                            :clearOnSelect="true"
                                            :disabled="true"
                                            :options="services_options"
                                        />
                                    </div>
                                </div>
                                <div class="col-xl-4 col-lg-4 col-md-4">
                                    <div
                                        class="form-field form-field--datepicker"
                                        ref="datepicker"
                                    >
                                        <label for="kickoff_date"
                                            >Kick-off date</label
                                        >
                                        <input
                                            type="text"
                                            id="kickoff_date"
                                            v-model="service.kickoff_date"
                                            name="kickoff_date"
                                            disabled
                                            style="max-width: 125px"
                                        />
                                        <button
                                            type="button"
                                            class="btn btn--icon"
                                            style="margin: 0 8px"
                                        >
                                            <i class="icon icon-calendar"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-xl-12 col-lg-12 col-md-12">
                                    <div class="form-field form-field--text">
                                        <label for="custom_service"
                                            >Custom service</label
                                        >
                                        <input
                                            type="text"
                                            id="custom_service"
                                            v-model="service.custom_service"
                                            name="custom_service"
                                            :disabled="true"
                                        />
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-xl-8 col-lg-8 col-md-8">
                                    <div
                                        class="form-field form-field--text"
                                        style="padding-right: 12px"
                                    >
                                        <label for="sow_file"
                                            >SOW
                                            <a
                                                :href="
                                                    service.sow.file_url ||
                                                    service.sow.url
                                                "
                                                v-if="service.sow"
                                                class="link"
                                                >View</a
                                            ></label
                                        >
                                        <input
                                            type="text"
                                            :disabled="true"
                                            id="sow_file"
                                            v-if="service.sow"
                                            v-model="service.sow.name"
                                            name="one-time-setup"
                                        />
                                    </div>
                                </div>
                                <div class="col-xl-4 col-lg-4 col-md-4">
                                    <div class="form-field form-field--text">
                                        <label for="amount">Amount</label>
                                        <input
                                            type="text"
                                            id="amount"
                                            v-model="service.amount"
                                            name="amount"
                                            :disabled="true"
                                        />
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-xl-8 col-lg-8 col-md-8">
                                    <div
                                        class="row details-inline-wrap form-box"
                                    >
                                        <span class="form-box-label">Type</span>
                                        <div
                                            class="form-field form-field--radiobutton"
                                        >
                                            <template v-for="t in types">
                                                <input
                                                    type="radio"
                                                    :id="`type_${t.id}`"
                                                    v-model="service.type.id"
                                                    checked
                                                    name="type_id"
                                                    class="type-create-deals js-edit-deal-type"
                                                    :value="t.id"
                                                    :disabled="true"
                                                />
                                                <label
                                                    style="
                                                        margin-bottom: 8px;
                                                        margin-right: 8px;
                                                    "
                                                    :for="`type_${t.id}`"
                                                    >{{ t.name }}</label
                                                >
                                            </template>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xl-4 col-lg-4 col-md-4">
                                    <div class="form-field form-field--text">
                                        <label for="amount"
                                            >Number of pmts</label
                                        >
                                        <input
                                            type="number"
                                            :disabled="true"
                                            id="number_of_pmts"
                                            v-model="service.num_of_payments"
                                            name="number_of_pmts"
                                        />
                                    </div>
                                </div>
                            </div>
                            <!--                            <div class="row">
                                <div class="col-xl-12 col-lg-12 col-md-12">
                                    <div
                                        class="form-field form-field&#45;&#45;textarea"
                                    >
                                        <label for="terms">Terms</label>
                                        <textarea
                                            id="terms"
                                            v-model="service.terms"
                                            name="terms"
                                            :disabled="true"
                                        ></textarea>
                                    </div>
                                </div>
                            </div>-->
                        </div>
                    </div>
                    <div class="row">
                        <div
                            class="form-field form-field--text"
                            style="margin-bottom: 12px"
                        >
                            <label
                                >Sale period: {{ current_sale_period }}</label
                            >
                        </div>
                    </div>
                    <div class="row jus-c--space-between row-values">
                        <div class="col-xl-2 col-lg-2 col-md-2 value-column">
                            <div class="form-field form-field--text">
                                <label for="amount_value"
                                    >Amount<span
                                        v-if="!is_required_status"
                                        class="red"
                                        >*</span
                                    ></label
                                >
                                <CurrencyInput
                                    type="text"
                                    id="amount_value"
                                    v-model="service_deal.amount_value"
                                    name="'amount_value'"
                                    :options="{
                                        currency: 'USD',
                                        hideCurrencySymbolOnFocus: false,
                                        hideGroupingSeparatorOnFocus: false,
                                        hideNegligibleDecimalDigitsOnFocus: false,
                                    }"
                                />
                                <span
                                    class="error"
                                    style="left: 0"
                                    v-if="errors.amount_value"
                                    >{{ errors.amount_value }}</span
                                >
                            </div>
                        </div>
                        <div class="col-xl-2 col-lg-2 col-md-2 value-column">
                            <div class="form-field form-field--text">
                                <label for="amount_value">Hard cost</label>
                                <CurrencyInput
                                    type="text"
                                    id="hard_cost"
                                    :disabled="is_gross_type"
                                    v-model="service_deal.hard_cost"
                                    name="'hard_cost'"
                                    :options="{
                                        currency: 'USD',
                                        hideCurrencySymbolOnFocus: false,
                                        hideGroupingSeparatorOnFocus: false,
                                        hideNegligibleDecimalDigitsOnFocus: false,
                                    }"
                                />
                                <span
                                    class="error"
                                    style="left: 0"
                                    v-if="errors.hard_cost"
                                    >{{ errors.hard_cost }}</span
                                >
                            </div>
                        </div>

                        <div class="col-xl-2 col-lg-2 col-md-2 value-column">
                            <div class="form-field form-field--text">
                                <label for="amount_value">Collected</label>

                                <CurrencyInput
                                    type="text"
                                    id="collected"
                                    v-model="service_deal.collected"
                                    name="'collected'"
                                    :options="{
                                        currency: 'USD',
                                        hideCurrencySymbolOnFocus: false,
                                        hideGroupingSeparatorOnFocus: false,
                                        hideNegligibleDecimalDigitsOnFocus: false,
                                    }"
                                />
                                <span
                                    class="error"
                                    style="left: 0"
                                    v-if="errors.collected"
                                    >{{ errors.collected }}</span
                                >
                            </div>
                        </div>

                        <div class="col-xl-2 col-lg-2 col-md-2 value-column">
                            <div class="form-field form-field--text">
                                <label for="amount_value">Commission,%</label>
                                <input
                                    type="text"
                                    :disabled="true"
                                    id="commission_procent"
                                    v-model="item.deal_commission"
                                    name="commission_procent"
                                />
                            </div>
                        </div>
                        <div class="col-xl-2 col-lg-2 col-md-2 value-column">
                            <div class="form-field form-field--text">
                                <label for="amount_value">Commission</label>
                                <CurrencyInput
                                    :readonly="true"
                                    type="text"
                                    id="commission_amount"
                                    v-model="service_deal.commission_amount"
                                    name="'commission_amount'"
                                    :options="{
                                        currency: 'USD',
                                        hideCurrencySymbolOnFocus: false,
                                        hideGroupingSeparatorOnFocus: false,
                                        hideNegligibleDecimalDigitsOnFocus: false,
                                    }"
                                />
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-xl-12 col-lg-12 col-md-12">
                            <div class="form-field form-field--textarea">
                                <label for="explanation">Explanation</label>
                                <textarea
                                    style="height: 100px"
                                    v-model="service_deal.explanation"
                                    id="explanation"
                                    name="explanation"
                                ></textarea>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-xl-6 col-lg-6 col-md-6">
                            <div
                                class="form-field form-field--tree"
                                style="padding-right: 12px"
                            >
                                <label for="cancel_reason"
                                    >No service provided reason</label
                                >
                                <treeselect
                                    v-model="service_deal.cancel_reason"
                                    id="cancel_reason"
                                    name="cancel_reason"
                                    :multiple="false"
                                    :clearable="false"
                                    :options="cancel_reason_options"
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row btn-wrap btn-wrap--center">
                    <button
                        @click.prevent="onSubmitEvent"
                        class="btn btn--gray"
                    >
                        Save
                    </button>
                    <button @click.prevent="handleClose" class="btn btn--gray">
                        Cancel
                    </button>
                </div>
            </div>
        </div>
        <AddSowModal
            v-if="is_add_new_sow"
            :onSubmit="onAddSowForService"
            :onClose="onCloseSowModal"
            :deal_id="deal_id"
            :brand_name="brand_name"
        />
    </div>
</template>

<script>
import AddSowModal from "./addSow.vue";
import CurrencyInput from "../../CurrencyInput";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import axios from "axios";

export default {
    name: "addContactModal",
    props: [
        "onClose",
        "service",
        "types",
        "item",
        "onUpdateList",
        "deal_commission_type_id",
        "max_hard_cost",
        "isRequired",
        "deal_id",
        "brand_name",
        "cancel_reasons",
        "sale_period",
    ],
    components: {
        Treeselect,
        AddSowModal,
        CurrencyInput,
    },
    data() {
        return {
            deal: {
                service_id: [0],
                number_of_pmts: 1,
                type: 1,
                amount: 1000,
                one_time_setup_fee: true,
                one_time_setup_value: 0,
                terms: "terms text",
            },
            service_deal: {
                amount_value: this.item.amount ?? 0,
                hard_cost: this.item.hard_cost ?? 0,
                collected: this.item.collected ?? 0,
                commission_amount: Number(
                    (this.item.collected / 100) * this.item.deal_commission
                ).toFixed(2),
                description: this.item.description,
                status_id: this.item.status_id,
                explanation: this.item.explanation ?? "",
                cancel_reason: this.item.cancel_reason_id ?? null,
            },
            errors: {
                amount_value: null,
                hard_cost: null,
                collected: null,
            },
            is_gross_type: false,
            is_required_status: false,

            is_add_new_sow: false,

            is_fluctuating_fee: false,
            cancel_reason_options: [],
        };
    },
    mounted() {
        console.log(this.brand_name);
        if (
            this.deal_commission_type_id &&
            this.deal_commission_type_id === 1
        ) {
            this.is_gross_type = true;
        }
        if (this.item.status_id && this.item.status_id === 1) {
            this.is_required_status = true;
        }

        if (this.item.deal_line_item.fluctuating_fee) {
            this.is_fluctuating_fee = true;
        }
        if (!this.service.services.length) {
            this.service.services = [
                {
                    id: null,
                    name: null,
                },
            ];
        }
        this.cancel_reason_options = this.cancel_reasons;
    },
    computed: {
        services_options() {
            return this.service.services.map((serv) => {
                return {
                    id: serv.id,
                    label: serv.name,
                };
            });
        },
        current_sale_period() {
            const _periodInput = document.querySelector("input[name='period']");

            if (!_periodInput) {
                return this.sale_period;
            }

            return _periodInput.value;
        },
    },
    watch: {
        "service_deal.collected"(newVal, oldVal) {
            this.service_deal.commission_amount = Number(
                (this.service_deal.collected / 100) * this.item.deal_commission
            ).toFixed(2);
        },
    },
    methods: {
        async handleSubmit() {
            this.validationValues();

            if (
                this.errors.amount_value ||
                this.errors.hard_cost ||
                this.errors.collected
            ) {
                return;
            }
            const total_data = await axios
                .patch("/sales/sale-line-items/update", {
                    id: this.item.id,
                    amount: this.service_deal.amount_value,
                    hard_cost: this.service_deal.hard_cost,
                    collected: this.service_deal.collected,
                    commission: this.service_deal.commission_amount,
                    description: this.service_deal.description,
                    explanation: this.service_deal.explanation,
                    cancel_reason_id: this.service_deal.cancel_reason,
                })
                .then((response) => {
                    const data = response.data;

                    return {
                        total_amount: data.total_amount,
                        total_collected: data.total_collected,
                        total_hard_cost: data.total_hard_cost,
                        total_commission: data.total_commission,
                    };
                });

            this.onUpdateList(
                this.item.id,
                {
                    id: this.item.id,
                    amount: this.service_deal.amount_value,
                    hard_cost: this.service_deal.hard_cost,
                    collected: this.service_deal.collected,
                    commission: Number(
                        (this.service_deal.collected / 100) *
                            this.item.deal_commission
                    ).toFixed(2),
                    explanation: this.service_deal.explanation,
                    cancel_reason_id: this.service_deal.cancel_reason,
                    description: this.service_deal.description,
                },
                total_data
            );

            this.handleClose();
        },

        onSubmitEvent() {
            if (
                this.service.type.id === 1 &&
                Number(this.service.amount.replace(/,/g, "")).toFixed(2) !==
                    Number(this.service_deal.amount_value).toFixed(2)
            ) {
                if (!this.service_deal.cancel_reason) {
                    this.is_add_new_sow = true;

                    return;
                }
            }

            this.handleSubmit();
        },

        handleClose(e) {
            this.onClose();
        },
        validationValues() {
            const numberRegex = /^[0-9]\d*(\.\d+)?$/;

            this.errors.amount_value = null;
            this.errors.hard_cost = null;
            this.errors.collected = null;

            if (
                !this.is_required_status &&
                this.service_deal.amount_value &&
                !numberRegex.test(this.service_deal.amount_value)
            ) {
                this.errors.amount_value = "Invalid value";
            } else if (
                this.is_required_status &&
                this.service_deal.amount_value < 0 &&
                !numberRegex.test(this.service_deal.amount_value)
            ) {
                this.errors.amount_value = "Invalid value";
            }

            if (
                this.service_deal.hard_cost &&
                !this.is_gross_type &&
                this.service_deal.hard_cost >
                    (this.service_deal.amount_value / 100) * this.max_hard_cost
            ) {
                this.errors.hard_cost =
                    "Max value " +
                    Math.floor(
                        (this.service_deal.amount_value / 100) *
                            this.max_hard_cost
                    );
            }

            if (
                !this.is_required_status &&
                !this.is_gross_type &&
                this.service_deal.hard_cost &&
                !numberRegex.test(this.service_deal.hard_cost)
            ) {
                this.errors.hard_cost = "Invalid value";
            } else if (
                this.is_required_status &&
                !this.is_gross_type &&
                this.service_deal.hard_cost < 0 &&
                !numberRegex.test(this.service_deal.hard_cost)
            ) {
                this.errors.hard_cost = "Invalid value";
            }

            if (
                !this.is_required_status &&
                this.service_deal.collected &&
                !numberRegex.test(this.service_deal.collected)
            ) {
                this.errors.collected = "Invalid value";
            } else if (
                this.is_required_status &&
                this.service_deal.collected < 0 &&
                !numberRegex.test(this.service_deal.collected)
            ) {
                this.errors.collected = "Invalid value";
            }
        },

        onAddSowForService(data) {
            let formData = new FormData();

            formData.append("sow_name", data.sow_name);
            formData.append("sow_date", data.sow_date);
            if (data.sow_file) formData.append("sow_file", data.sow_file);
            formData.append("sow_url", data.sow_url);
            formData.append("sow_description", data.sow_description);
            formData.append("id", this.item.id);
            formData.append("type", data.sow_type);
            formData.append("valid_date", data.sow_valid_date);
            formData.append("amount", this.service_deal.amount_value);
            formData.append("collected", this.service_deal.collected);
            formData.append("description", this.service_deal.description);
            formData.append("hard_cost", this.service_deal.hard_cost);

            axios
                .post("/deals/deal-line-items/update-by-retainer", formData, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                })
                .then(async (res) => {
                    const { item = null, total = null } = res.data;

                    if (item || total) {
                        this.onUpdateList(
                            this.item.id,
                            {
                                id: this.item.id,
                                amount: item.amount,
                                hard_cost: item.hard_cost,
                                collected: item.collected,
                                deal_line_item: item.deal_line_item,
                            },
                            {
                                total_amount: total.total_amount,
                                total_collected: total.total_collected,
                                total_hard_cost: total.total_hard_cost,
                                total_commission: total.total_commission,
                            }
                        );
                    }
                    this.is_add_new_sow = false;
                    this.handleClose();
                })
                .catch((err) => console.error(err));
        },

        onCloseSowModal() {
            this.is_add_new_sow = false;
        },
    },
};
</script>
